/******************************************************************************************
 *	Customers List Snapshot
 *******************************************************************************************
 *
 * Holds information about the segment and payload of the customers list.
 * Used to restore the segment and payload when navigating back from Customer Details page.
 *
 */
(function() {
  

  angular
    .module('rcServices.customersListSnapshot', [])
    .service('CustomersListSnapshot', function() {
      var state = {
        segment: null,
        payload: null,
        sidebarExpanded: null,
        currentSort: null
      };
      this.set = function(segment, payload, sidebarExpanded, currentSort) {
        state.segment = segment;
        state.payload = payload;
        state.sidebarExpanded = sidebarExpanded;
        state.currentSort = currentSort;
      };
      this.getSegment = function() {
        return state.segment;
      };
      this.getPayload = function() {
        return state.payload;
      };
      this.isSidebarExpanded = function() {
        return state.sidebarExpanded;
      };
      this.getCurrentSort = function() {
        return state.currentSort;
      };
      this.clear = function() {
        state.segment = null;
        state.payload = null;
        state.sidebarExpanded = null;
        state.currentSort = null;
      };
    });
})();
